import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

const PublicRoute = () => {
  const { isAuthenticated, userData } = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && userData) {
      if (userData?.role === "admin") {
        navigate("/admin/posts");
      } else {
        navigate("/dashboard");
      }
    }
  }, [isAuthenticated, userData, navigate]);

  return <Outlet />;
};

export default PublicRoute;
